const pageLinkTotalSum = document.querySelector('.page-link__total-sum');

if (pageLinkTotalSum)  {
    initPriceList();
    changeBtnText();
}

function changeBtnText() {
    const totalSumBtnText = document.querySelector('.js-maintenance-regulations-btn-text');

    if (!totalSumBtnText) {
        return;
    }

    if (window.innerWidth <= 767) {
        totalSumBtnText.textContent = 'Стоимость';
    }   else {
        totalSumBtnText.textContent = 'Ориентировочная стоимость';
    }
}

window.onresize = changeBtnText;

function parsePrice(value) {
    return Number(String(value).replace(/\D+/g, '')) || 0;
}

function formatPrice(value) {
    return String(Math.round(value)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

// Пересчёт суммы услуг для ТО
function calculatePriceListSum() {
    const hasModelTabs = document.querySelector('.maintenance-regulations__tabs-list--model');

    const items = hasModelTabs ? Array.from(document.querySelectorAll('.maintenance-regulations__slider-item--model._selected .js-maintenance-regulations-item-sum[data-price]')) : Array.from(document.querySelectorAll('.js-maintenance-regulations-item-sum[data-price]'))
        .filter((item) => item.closest('.swiper-slide-active'));

    return items.reduce((total, item) => total + parsePrice(item.dataset.price), 0);
}

// Инициализация пересчёта общей суммы на кнопке в блоке
function initPriceList() {
    const totalSumNode = document.querySelector('.js-maintenance-regulations-total-sum');
    const serviceNameNode = document.querySelector('.js-maintenance-regulations-service-name');
    const priceButtons = document.querySelectorAll('.maintenance-regulations__service-tab');
    const hasModelTabs = document.querySelector('.maintenance-regulations__tabs-list--model');

    if (!totalSumNode) return;

    const animateValue = (from, to, onUpdate, duration = 350) => {
        const start = performance.now();
        const step = (now) => {
            const progress = Math.min((now - start) / duration, 1);
            const current = Math.round(from + (to - from) * progress);
            onUpdate(current);
            if (progress < 1) requestAnimationFrame(step);
        };

        requestAnimationFrame(step);
    };

    const updateServiceName = (button) => {
        const serviceName = button?.textContent?.trim();

        if (!serviceName) return;

        // Обновляем основной элемент
        if (serviceNameNode) {
            serviceNameNode.value = serviceName;
            serviceNameNode.textContent = serviceName;
        }

        // Обновляем поле формы в модальном окне
        const modalForm = document.querySelector('#modal-planovoe-to');
        if (modalForm) {
            const serviceInput = modalForm.querySelector('input[name="fields[service]"]');
            if (serviceInput) {
                serviceInput.value = serviceName;
            }
        }

        // Обновляем span в модальном окне
        const modalServiceSpan = document.querySelector('.modal__info-parameter .modal__info-service');
        if (modalServiceSpan) {
            modalServiceSpan.textContent = serviceName;
        }
    };

    // Изменение общей стоимости услуг на кнопке
    const updateTotalSum = () => {
        const nextSum = calculatePriceListSum();
        const currentSum = parsePrice(totalSumNode.value || totalSumNode.textContent);

        animateValue(currentSum, nextSum, (value) => {
            const formatted = formatPrice(value);

            // Обновляем основной элемент
            totalSumNode.value = value;
            totalSumNode.textContent = "от " + formatted;

            // Обновляем поле формы в модальном окне
            const modalForm = document.querySelector('#modal-planovoe-to');
            if (modalForm) {
                const totalPriceInput = modalForm.querySelector('input[name="fields[total_price]"]');
                if (totalPriceInput) {
                    totalPriceInput.value = `от ${value} ₽`;
                }
            }

            // Обновляем span в модальном окне с " ₽"
            const modalTotalSpan = document.querySelector('.modal__info-parameter .modal__info-total');
            if (modalTotalSpan) {
                modalTotalSpan.textContent = `от ${formatted} ₽`;
            }
        });
    };

    // ---------- РЕЖИМ БЕЗ МОДЕЛЕЙ (обычный прайс) ----------
    if (!hasModelTabs) {
        priceButtons.forEach((button) => {
            button.addEventListener('click', () => {
                updateServiceName(button);
                updateTotalSum();
            });
        });

        // Функция для обновления при смене таба
        const updateOnTabChange = () => {
            const activeTab = document.querySelector('.maintenance-regulations__tab._selected, .maintenance-regulations__service-tab._selected');
            if (activeTab) {
                const serviceName = activeTab.textContent?.trim();
                if (serviceName) {
                    const tempButton = {textContent: serviceName};
                    updateServiceName(tempButton);
                    updateTotalSum();
                }
            }
        };

        // Обновление при смене таба через клик
        const tabsItems = document.querySelectorAll('.maintenance-regulations__tab, .maintenance-regulations__service-tab');
        tabsItems.forEach((tab) => {
            tab.addEventListener('click', () => {
                // Находим активный таб после клика (с задержкой, чтобы класс успел обновиться)
                setTimeout(updateOnTabChange, 50);
            });
        });

        // Также обновляем при смене слайда через swiper
        const swiperEl = document.querySelector('.js-maintenance-regulations-slider');
        if (swiperEl) {
            // Пытаемся получить swiper сразу, если он уже инициализирован
            if (swiperEl.swiper) {
                swiperEl.swiper.on('slideChange', updateOnTabChange);
            } else {
                // Если swiper еще не инициализирован, ждем его создания
                const observer = new MutationObserver(() => {
                    if (swiperEl.swiper) {
                        swiperEl.swiper.on('slideChange', updateOnTabChange);
                        observer.disconnect();
                    }
                });
                observer.observe(swiperEl, {attributes: true, attributeFilter: ['class']});

                // Также проверяем через небольшую задержку
                setTimeout(() => {
                    if (swiperEl.swiper && !swiperEl.swiper.destroyed) {
                        swiperEl.swiper.on('slideChange', updateOnTabChange);
                    }
                }, 100);
            }
        }

        return;
    }

    // ---------- РЕЖИМ С МОДЕЛЯМИ ----------

    const tabModels = document.querySelectorAll('.maintenance-regulations__tab--model');
    const modelTabsLists = document.querySelectorAll('.maintenance-regulations__tabs-list--model');
    // тут exception или ошибки не будет т.к. modelTabsLists при выборке, если значений нет, возвращает пустой массив
    const modelServiceTabsList = Array.from(modelTabsLists)
        .find((list) => list.querySelector('.maintenance-regulations__service-tab'));
    const modelSlides = document.querySelectorAll('.maintenance-regulations__slider-item--model');

    const updateModelState = (selectedModel, selectedTabValue) => {
        if (!selectedModel || !modelServiceTabsList) return;

        const serviceTabs = modelServiceTabsList.querySelectorAll('.maintenance-regulations__service-tab');

        let firstMatchTab = null;
        let activeServiceTab = null;

        serviceTabs.forEach((tab) => {
            const sameModel = tab.dataset.model === selectedModel;

            tab.classList.toggle('_show', sameModel);

            if (sameModel && !firstMatchTab) {
                firstMatchTab = tab;
            }
        });

        // Если таб явно выбран (клик по .maintenance-regulations__service-tab)
        if (selectedTabValue) {
            serviceTabs.forEach((tab) => {
                const isActive = tab.dataset.model === selectedModel && (tab.dataset.tab === selectedTabValue || tab.textContent.trim() === selectedTabValue);

                tab.classList.toggle('_selected', isActive);
                if (isActive) activeServiceTab = tab;
            });
        }

        // Если не передали конкретный таб — берем первый подходящий
        if (!activeServiceTab && firstMatchTab) {
            activeServiceTab = firstMatchTab;
            serviceTabs.forEach((tab) => tab.classList.remove('_selected'));
            activeServiceTab.classList.add('_selected');
        }

        if (!activeServiceTab) return;

        const tabValue = activeServiceTab.dataset.tab || activeServiceTab.textContent.trim();

        // Синхронизируем слайдер по data-tab и data-model
        modelSlides.forEach((slide) => {
            const isSlideActive = slide.dataset.model === selectedModel && slide.dataset.tab === tabValue;

            slide.classList.toggle('_selected', isSlideActive);
        });

        // Обновляем название услуги и сумму
        updateServiceName(activeServiceTab);
        updateTotalSum();
    };

    // Клик по табу модели
    tabModels.forEach((tab) => {
        tab.addEventListener('click', () => {
            const selectedModel = tab.dataset.model;

            // Переключаем _selected между табами моделей
            tabModels.forEach((item) => item.classList.remove('_selected'));
            tab.classList.add('_selected');

            // Обновляем .modal__info-value: вставляем тег data с selectedModel
            const modalInfoValue = document.querySelector('.modal__info-value');
            if (modalInfoValue && selectedModel) {
                // Ищем существующий тег data или создаем новый
                let dataElement = modalInfoValue.querySelector('data.js-model-value');

                // Сохраняем исходный textContent при первом клике (когда dataElement еще не существует)
                if (!dataElement && !modalInfoValue.dataset.originalText) {
                    modalInfoValue.dataset.originalText = modalInfoValue.textContent?.trim() || '';
                }

                if (!dataElement) {
                    dataElement = document.createElement('data');
                    dataElement.className = 'js-model-value';
                    modalInfoValue.appendChild(dataElement);
                }

                // Устанавливаем value и textContent в data тег
                dataElement.value = selectedModel;
                dataElement.textContent = ' ' + selectedModel;

                // Обновляем поле формы fields[car_brand]
                const modalForm = document.querySelector('#modal-planovoe-to');
                if (modalForm) {
                    const carModelInput = modalForm.querySelector('input[name="fields[model_code]"]');
                    if (carModelInput) {
                        carModelInput.value = selectedModel;
                    }
                }
            }

            updateModelState(selectedModel);
        });
    });

    // Клик по .maintenance-regulations__service-tab в режиме моделей
    priceButtons.forEach((button) => {
        button.addEventListener('click', () => {
            const selectedModel = button.dataset.model;
            const tabValue = button.dataset.tab || button.textContent.trim();

            updateModelState(selectedModel, tabValue);
        });
    });
}

// Инициализация перетаскивания мышью для .maintenance-regulations__tabs-scroll
const tabsPriceElements = document.querySelectorAll('.maintenance-regulations__tabs-scroll');

tabsPriceElements.forEach((element) => {
    let isDown = false;
    let startX;
    let scrollLeft;

    element.addEventListener('mousedown', (e) => {
        isDown = true;
        element.style.cursor = 'grabbing';
        startX = e.pageX - element.offsetLeft;
        scrollLeft = element.scrollLeft;
        e.preventDefault();
    });

    element.addEventListener('mouseleave', () => {
        isDown = false;
        element.style.cursor = 'grab';
    });

    element.addEventListener('mouseup', () => {
        isDown = false;
        element.style.cursor = 'grab';
    });

    element.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - element.offsetLeft;
        const walk = (x - startX) * 1; // Скорость прокрутки
        element.scrollLeft = scrollLeft - walk;
    });
});

